<style lang="scss" scoped>
	.channelName{
		width: 55%;
		float: left;
		margin-right: 10px;
	}
	.creareform .vview-formitem {
    margin-bottom: 10px;
	line-height: 32px;

}
</style>

<template>
    <div>
        <compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary">
            <compFormEdit class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" ref="baseform" />
		</compWrapper>
		<compWrapper :title="$t('erp.channelbase.interface_info', { defaultValue: '接口信息' })" theme="primary">
            <comAddamazon class="margin-top-15 margin-right-15" ref="amazonchild" :parentCountries="parentCountries"></comAddamazon>
		</compWrapper>
		<compWrapper :title="$t('erp.channelbase.order_info', { defaultValue: '订单相关信息' })" theme="info">
            <compFormEdit class="margin-top-15 margin-right-15" :formdata="getOrder" v-model="formData" />
		</compWrapper>
		<compWrapper :title="$t('global.common.other_information', { defaultValue: '其他信息' })" theme="info">
            <compFormEdit class="margin-top-15 margin-right-15" :formdata="getOther" v-model="formData" />
			<div class="text-right padding-right-20" v-show="type!='query'">
				<vButton theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: '确定' })}}</vButton>
				<vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
			</div>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>

import { mapState, mapGetters } from "vuex";
import { HttpSysOpLog } from '@/service/boss/allot';
import { HttpSaveAccountChild, HttpGetParentCountry, HttpGetTitleAndInit } from "@/service/managechannel/managechannel";
import addchildTablelist from "./addchildTablelist.vue";
import comAddamazon from "./addchildamazon.vue";
import { connect } from 'net';
export default {
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("../channelbase/log"),
        addchildTablelist,
        comAddamazon,
    },
    data(){
        return {
			type: this.$route.params.type,
			id:this.$route.query.id,
			query: false,
			formData:{
				// shipType: 0,
				orderOnlyShow:"N",
				isLineRelate:"N",
				saleType:'retailer',
				timeoutDays:3,
				lineRelateId:0,
				defaultManMadeShipment:0,
                isAccountPay:0,
                issueAccountPay:0,
				isOpenSFP:0,
				allowUpdate:0,
			},
			queryFormData:{},
			parentCountries: [],
			showtip:"",
			styWidth : 210,
			countryList:[
				{label:this.$t('erp.channelbase.north_america', { defaultValue: '北美' }),areaCode:'North America'},
				{label:this.$t('erp.channelbase.europe', { defaultValue: '欧洲' }),areaCode:'Northwest Europe'},
				{label:this.$t('erp.channelbase.asia', { defaultValue: '亚洲' }),areaCode:'Asia'},
			],
			flaglist:[],
			titlelist:[],
			initlist:[],
			loading:false,
			nowdate:'',
        }
    },
    created(){
		this.getNowFormatDate()
	},
    computed:{
        ...mapState("boss", ["accounts", "warehouseList",'products','sysdeliveries', 'newSysdeliveries']),
		...mapGetters('common',['getMarketplaceId']),

		accountsAll(){
            return this.accounts.sort(function(a,b){
                return a.title.localeCompare(b.title)
            })
		},
		productList(){
			return [{
				id:0,
				name:'Others'
			},...this.products]
		},
        getBase() {
			return [
            {
                label: this.$t('erp.channelbase.main_account_name', { defaultValue: "主账号名称" }),
                key: "flag",
                span: 12,
                props:{
                    readonly:true
                },
                children:(h)=>{
                    return <vIcon
                    type="search"
                    center
                    slot="suffix"
                    style="padding:6px;pointer-events: initial;"
                    size="18"
                    nativeOnClick={this.handleModalplat.bind(this)}
                />
                },
                formItem:{
                    labelWidth:this.styWidth,
                    tip: `<div class="color-error">${this.$t('erp.channelbase.main_account_tip', { defaultValue: '若主账号已创建，新增子账号时则需做关联，否则会导致重复抓取数据' })}</div>`,
                },
            },
			{
				label: this.$t('erp.channelbase.start_running_time', { defaultValue: "开始运营时间" }),
				tag: 'vDatepicker',
				key: 'beginSalesDate',
				required:false,
				props:{
					format:'yy-mm-dd',
					confirm:false,
				},
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.account_starting_runing_tip', { defaultValue: '账号的开始运营时间,接口会从开始运营时间自动获取订单，不填则默认当前时间' })}</div>`,
				}
            },
            {
				label: this.$t('global.common.notes', { defaultValue: "备注" }),
				key: "remark",
				tag:'vTextarea',
				required:false,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			];
		},
		getOrder(){
			const _this = this
			return [
			// query1
			{
				label: this.$t('erp.channelbase.sale_type', { defaultValue: "销售方式" }),
				// key: "saleType",
				tag: 'div',
				required: false,
				show:this.query,
				valueText:this.formData.saleType=='retailer'?this.$t('erp.b2c.ordertype_normally', { defaultValue: '正常销售' }):this.$t('erp.channelbase.part_sale_channel', { defaultValue: '分销渠道' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.sale_type', { defaultValue: "销售方式" }),
				key: "saleType",
				tag: 'vSelect',
				required: false,
				show:!this.query,
				options: [
					{
						value: 'retailer',
						label: this.$t('erp.b2c.ordertype_normally', { defaultValue: '正常销售' })
					},
					{
						value: 'dropship',
						label: this.$t('erp.channelbase.part_sale_channel', { defaultValue: '分销渠道' })
					},
				],
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtipcreate && this.formData.saleType=='retailer' ? '' : `<div class="color-error">${this.$t('erp.channelbase.system_order_tip', { defaultValue: '分销渠道:系统订单会根据渠道对应关系自动的把价格更新为分销的价格' })}</div>`,
					style:"margin-bottom:30px"
				}
			},
			// query2
			{
				label: this.$t('erp.channelbase.send_allow_max_days', { defaultValue: "发货允许最大天数" }),
				key: "timeoutDays",
				required: false,
				show:this.query,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.send_allow_max_days', { defaultValue: "发货允许最大天数" }),
				key: "timeoutDays",
				required: false,
				show:!this.query,
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.max_days_tip', { defaultValue: '超过最大天数订单会变为发货超时订单。若平台有发运允许最大天数，以平台为准' })}</div>`,
					style:"margin-bottom:30px"
				}
			},
			// query3
			{
				label: this.$t('erp.channelbase.order_tip', { defaultValue: "订单是否默认为展示订单" }),
				key: "orderOnlyShow",
				required: false,
				show:this.query,
				valueText:this.formData.orderOnlyShow=='Y'?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label:  this.$t('erp.channelbase.order_tip', { defaultValue: "订单是否默认为展示订单" }),
				key: "orderOnlyShow",
				tag:"vRadio",
				required: false,
				show:!this.query,
				valueText: this.formData.orderOnlyShow=='Y'?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				props: {
					strict: false,
				},
				options: [{
					trueValue: 'Y',
					label: this.$t('erp.global.yes', { defaultValue: '是' })
				}, {
					trueValue: 'N',
					label: this.$t('erp.global.no', { defaultValue: '否' })
				}],
				formItem:{
					labelWidth:this.styWidth,
					style:"margin-bottom:30px",
				}
			},
			// query4
			{
				label: this.$t('erp.channelbase.is_default_hand_send', { defaultValue: "是否默认手动发货" }),
				key: "defaultManMadeShipment",
				required: false,
				show:this.query,
				valueText:this.formData.defaultManMadeShipment==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.is_default_hand_send', { defaultValue: "是否默认手动发货" }),
				key: "defaultManMadeShipment",
				tag:"vRadio",
				required: false,
				show:!this.query,
				props: {
					strict: false,
				},
				options: [{
					trueValue: 1,
					label: this.$t('erp.global.yes', { defaultValue: '是' })
				}, {
					trueValue: 0,
					label: this.$t('erp.global.no', { defaultValue: '否' })
				}],
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtipcreate && this.formData.defaultManMadeShipment==0 ? '' : `<div class="color-error">${this.$t('erp.channelbase.channel_product_tip', { defaultValue: '该渠道的所有产品，会默认手动发货，也支持前往渠道产品管理中再对各seller sku的发货属性进行修改' })}</div>`,
					style:"margin-bottom:30px"
				}
			},
			// query5
			{
				label: this.$t('erp.channelbase.not_connect_order', { defaultValue: "未关联项目的订单是否默认为展示单" }),
				key: "isLineRelate",
				required: false,
				show:this.query,
				valueText:this.formData.isLineRelate=='Y'?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.not_connect_order', { defaultValue: "未关联项目的订单是否默认为展示单" }),
				key: "isLineRelate",
				tag:"vRadio",
				show:!this.query,
				required: false,
				valueText: this.formData.isLineRelate=='Y'?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				props: {
					strict: false,
				},
				options: [{
					trueValue: 'Y',
					label: this.$t('erp.global.yes', { defaultValue: '是' })
				}, {
					trueValue: 'N',
					label: this.$t('erp.global.no', { defaultValue: '否' }),
				}],
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			// query6
			{
				label: this.$t('erp.channelbase.not_connection_project', { defaultValue: "未关联项目的订单默认关联项目" }),
				tag: 'vSelect',
				key: "lineRelateId",
				required: false,
				show:this.query,
				valueText: (
					this.productList.find(item => {
						return (
							this.formData.lineRelateId == item.id
						);
					}) || {}
				).name,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.not_connection_project', { defaultValue: "未关联项目的订单默认关联项目" }),
				tag: 'vSelect',
				key: "lineRelateId",
				show:!this.query,
				required: false,
				options:this.productList.map(function(item){
					const {id,name}=item;
					return {
						value: id,
						label:name
					}
				}),
				formItem:{
					labelWidth:this.styWidth,
				},
				props:{
					filterable:true,
				}

			},
			// query7
			{
				label: this.$t('erp.channelbase.is_channel_pay_cost', { defaultValue: "是否渠道支付运费" }),
				key: "isAccountPay",
				required: false,
				show:this.query,
				valueText:this.formData.isAccountPay==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.is_channel_pay_cost', { defaultValue: "是否渠道支付运费" }),
				key: "isAccountPay",
				tag:"vRadio",
				show:!this.query,
				required: false,
				valueText: this.formData.isAccountPay==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				props: {
					strict: false,
				},
				options: [{
					trueValue: 1,
					label: this.$t('erp.global.yes', { defaultValue: '是' })
				}, {
					trueValue: 0,
					label: this.$t('erp.global.no', { defaultValue: '否' })
                }],
                on:{
                    'on-change':(val)=>{
                        // console.log(val)
                        this.formData.issueAccountPay = val
                    }
                },
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			// query8
			{
				label: this.$t('erp.channelbase.is_open_sfp', { defaultValue: "是否开启SFP" }),
				key: "isOpenSFP",
				required: false,
				show:this.query,
				valueText:this.formData.isOpenSFP==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.is_open_sfp', { defaultValue: "是否开启SFP" }),
				key: "isOpenSFP",
				tag:"vRadio",
				required: false,
				show:!this.query,
				valueText:this.formData.isOpenSFP==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				props: {
					strict: false,
				},
				options: [{
					trueValue: 1,
					label: this.$t('erp.global.yes', { defaultValue: '是' })
				}, {
					trueValue: 0,
					label: this.$t('erp.global.no', { defaultValue: '否' }),
				}],
				formItem:{
					labelWidth:this.styWidth,
				}
            },
            // query8
			{
				label: this.$t('erp.channelbase.bufa_is_channel_pay_cost', { defaultValue: "补发单是否渠道支付运费" }),
				required: false,
				show:this.query,
				valueText:this.formData.issueAccountPay==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.bufa_is_channel_pay_cost', { defaultValue: "补发单是否渠道支付运费" }),
				key: "issueAccountPay",
				tag:"vRadio",
				required: false,
				show:!this.query,
				// valueText:this.formData.isOpenSFP=='1'?'是':'否',
				props: {
					strict: false,
				},
				options: [{
					trueValue: 1,
					label: this.$t('erp.global.yes', { defaultValue: '是' })
				}, {
					trueValue: 0,
					label: this.$t('erp.global.no', { defaultValue: '否' }),
				}],
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			// // query9
			{
				label: this.$t('erp.channelbase.carrier_upload_attach', { defaultValue: "哪些carrier需要上传附件" }),
				key: "bossShippingMethodCode",
				required: false,
				show:this.query,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.carrier_upload_attach', { defaultValue: "哪些carrier需要上传附件" }),
				key: "bossShippingMethodCode",
				tag:'vSelect',
				required: false,
				show:!this.query,
				options:this.newSysdeliveries.map(function(item){
					// console.log(item)
					const {carrierServiceCode}=item;
					return {
						value: carrierServiceCode,
						label: carrierServiceCode
					}
				}),
				props:{
					filterable:true,
					multiple:true,
				},
				formItem:{
					labelWidth:this.styWidth,
				},
			},
			// query10
			{
				label: this.$t('erp.channelbase.is_allow_update_state', { defaultValue: "是否允许更新发货状态" }),
				key: "allowUpdate",
				required: false,
				show:this.query,
				valueText:this.formData.allowUpdate==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.is_allow_update_state', { defaultValue: "是否允许更新发货状态" }),
				key: "allowUpdate",
				tag:"vRadio",
				required: false,
				show:!this.query,
				valueText:this.formData.allowUpdate==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				props: {
					strict: false,
				},
				options: [{
					trueValue:1,
					label: this.$t('erp.global.yes', { defaultValue: '是' })
				}, {
					trueValue: 0,
					label: this.$t('erp.global.no', { defaultValue: '否' }),
				}],
				formItem:{
					labelWidth:this.styWidth,
				}
			},

			];
		},
		getOther(){
			return [{
				label: this.$t('erp.channelbase.channel_currency', { defaultValue: "渠道币种" }),
				key: "currency",
				show:this.query,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.vat_sale', { defaultValue: "VAT销售税税率" }),
				show:this.query,
				valueText:this.formData.vatRate +' %',
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.account_incharge', { defaultValue: "账号负责人 " }),
				key: "manageUserTels",
				required:false,
				span:24,
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.account_exception_tip', { defaultValue: '账号发生异常会自动提醒账号的负责人，请填写负责人手机号，若有多个可用逗号隔开' })}</div>`,
					style:"width:50%"
				},
				props:{
					placeholder: this.$t('erp.channelbase.input_phone_incharge', { defaultValue: '请填写负责人手机号，若有多个可用逗号隔开' }),
				}
			},
			{
				label: this.$t('erp.channelbase.auth_date', { defaultValue: "授权日期" }),
				tag: 'vDatepicker',
				key: 'authorizationAt',
				// query:this.type == 'query',
				required:false,
				props:{
					format:'yy-mm-dd',
					confirm:false,
					placeholder:this.$t('erp.channelbase.auth_date_tip', { defaultValue: '授权到期前15天，自动提醒账号负责人' }),
				},
				formItem:{
					labelWidth:this.styWidth,
				}
            },
			];
		},
    },
    methods:{
        handleModalplat() {
			this.$VModal.info({
				title: this.$t('erp.channelbase.main_account_query', { defaultValue: "主账号查询" }),
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement("addchildTablelist",{
						props:{
							flaglist:this.flaglist,
							titlelist:this.titlelist,
							initlist:this.initlist,
						},
                        on:{
                            rows:(rows)=>{
								// console.log(rows)
								this.$set(this.formData,'flag',rows.flag)
								this.getParentCountry(rows.accountInit)
                                this.$VModal.destroy();
							},
							cancel:()=>{
								this.$VModal.destroy();
							}
                        }
                    })
				}
			})
		},
		// 请求主账号带的区域国家
		getParentCountry(data){
			HttpGetParentCountry({
				init:data
			}).then(res=>{
				let data = res.data
				data.areaCountryRequest.map(item=>{
					item.countryRequest.map(json=>{
						let a = JSON.parse(json.connectStr)
						json.connectStr = a
					})
				})
				this.parentCountries = data
				// console.log(data)
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
		getNowFormatDate(){
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
			this.nowdate =  currentdate;
			this.formData.beginSalesDate = currentdate
			this.getTitle()
            // console.log(this.nowdate)
		},
		getTitle(){
			HttpGetTitleAndInit().then(res=>{
				this.flaglist = res.data.flag
				this.titlelist = res.data.title
				this.initlist = res.data.init
			},err=>{

			})
		},
		// handleResponse(data={}){
		// 	this.formData = data
		// 	this.formData.type == data.type
		// },
		async submit(){
			const valid = await this.$refs['baseform'].validate();
			if (!valid) return;
			// amazonchild
			// this.$refs.amazonchild
			let bool1 = await this.$refs.amazonchild.validate();
			if (!bool1) return;

			// let ismain;
			let array = [],countries = [];
			// 亚马逊的提交数据类型
			this.$refs.amazonchild.formData.areaCode.map((item)=>{
				countries = []
				let obj = {
					"product":"N",
					"order":"N",
					"report":"N",
					"finance":"N",
					"inbound":"N",
					"outbound":"N",
					"stock":"N"
				};
				let alist = this.$refs.amazonchild.getCountryList(item)
				// console.log(this.$refs.amazonchild.getCountryList(item))
				let checkismain = alist[this.$refs.amazonchild.formData1[item].isMain]
				this.$refs.amazonchild.formData1[item].countryCode.map((country,index)=>{
					this.$refs.amazonchild.formData1[item].isProduct.map((json)=>{
						obj[json] = 'Y'
					})
					if(checkismain==undefined){
						this.$VMessage.error(this.$t('erp.channelbase.please_choose_default_main_account', { defaultValue: '请勾选默认主账号' }));
					}
					let data = {
						countryCode:country,
						isMain: checkismain.value == country ? '1' : '0',
						connectStr:{
							new_flag: obj,
							merchantToken:this.$refs.amazonchild.formData1[item].merchantToken,
							mwsAuthToken:this.$refs.amazonchild.formData1[item].mwsAuthToken,
							sellerId:this.$refs.amazonchild.formData1[item].sellerId,
							marketplaceId:this.getMarketplaceId[country]
						}
					}
					
					data.connectStr = JSON.stringify(data.connectStr)
					countries.push(data)
				})
				let data1 = {
					areaCode : item,
					countryRequest:countries
				}
				array.push(data1)
			})
			this.formData.orgId = this.parentCountries.orgId
			this.formData.title = this.parentCountries.title
            this.formData.siteName = this.parentCountries.siteName
			this.formData.channelCategoryId = this.parentCountries.channelCategoryId
			this.formData.type = this.parentCountries.type
			this.formData.init = this.parentCountries.init
			
			// console.log(array)

            HttpSaveAccountChild({
                areaCountryRequest:array,
                ...this.formData,
			}).then(res=>{
				this.$VMessage.success(res.message);
				this.$router.push({ name: "channelBase" })
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		cancel(){
			this.$router.push({ name: "channelBase" })
		}
    }
}
</script>



